module.exports = __webpack_public_path__ + "static/img/group621.8cc5b35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/group621.png
// module id = cPHW
// module chunks = 1